import React from "react";
import { withRouter } from "react-router-dom";
import backiconstyles from "./backicon.module.css";

function BackIcon(props) {
  return (
    <>
      <i
        className={`fas fa-chevron-left ${backiconstyles.backIcon}`}
        onClick={() => props.history.goBack()} style={props.style}
      >
      </i>
    </>
  );
}

export default withRouter(BackIcon);
